import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import { required, maxLength} from "vuelidate/lib/validators";
import CONFIG from "@/assets/js/config.js";
import ShiftPatternService from "@/services/ShiftPatternService";
import store from "@/store";
import ValidationService from "@/services/ValidationService";

export default {
  name: "shiftPatternEdit",
  mixins: [ValidationService],
  directives: {
    error: {
      bind(el, binding) {
        removeValidationError(el);
        if (binding.value) {
          insertValidationError(el, binding.value);
        }
      },
      inserted(el, binding) {
        removeValidationError(el);
        if (binding.value) {
          insertValidationError(el, binding.value);
        }
      },
      componentUpdated(el, binding) {
        removeValidationError(el);
        if (binding.value) {
          insertValidationError(el, binding.value);
        }
      },
    },
  },
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      patternDetail: [],
      pattern_name: "",
      pattern_group: null,
      days: CONFIG.DAYS,
      selectedShiftsByDay: {},
      selectedDays: {},
      submitted: false,
      disabled: false,
      shiftLists: {},
      shiftErrorData: {},
    };
  },

  validations: {
    pattern_name: {
      required,
      maxLength: maxLength(100)
    }
  },

  methods: {
    clearValidationErrors() {
      this.validationErrors = {};
      const root = this.$el || document;
      const errorEls = root.querySelectorAll('.validation-error');
      errorEls.forEach(el => el.remove());
    },

    fetchPatternDetail() {
      this.isLoading = true;
      axios.get('/shift-pattern/' + this.$route.params.id + '/info', {
        params: { campus_id: store.state.user.campus_id }
      })
      .then((response) => {
        this.patternDetail = response.data.patternInfo;
        if (this.patternDetail.length) {
          const firstPattern = this.patternDetail[0];
          this.pattern_name = firstPattern.pattern_name; 
          this.pattern_group = firstPattern.pattern_group;
          ShiftPatternService.defineCheckForDayAndShifts(this.patternDetail, this.selectedDays, this.selectedShiftsByDay, this.$set)
        }
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.log(err)
      })
      .finally(() => {
        this.isLoading = false;
      })
    },

    fetchShifts() {
      this.isLoading = true;
      axios.get("/shift/setting/by-time")
      .then((response) => {
        this.shiftLists = response.data.shifts;
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.log(err)
      })
      .finally(() => {
        this.isLoading = false;
      })
    },

    dayHasError(dayId) {
      return ShiftPatternService.dayHasError(dayId, this.selectedDays, this.selectedShiftsByDay, this.submitted);
    },

    shiftHasError(dayId) {
      return ShiftPatternService.shiftHasError(dayId, this.selectedDays, this.selectedShiftsByDay, this.submitted);
    },

    isShiftOverlapped(shiftId, dayId) {
      return ShiftPatternService.defineShiftOverlapped(shiftId, dayId, this.shiftErrorData, this.selectedShiftsByDay)
    },

    getSpecificShiftErrorMessage(shiftId, dayId) {
      return ShiftPatternService.defineOverlapErrMsg(shiftId, dayId, this.shiftErrorData)
    },

    async confirmCreatePattern() {
      this.clearValidationErrors();
      this.submitted = true;
      if (this.$v.invalid || !this.pattern_name.trim()) {
        this.disabled = false;
        return;
      }

      const dayErrorExists = Object.keys(this.selectedDays).some(dayId =>
        ShiftPatternService.dayHasError(dayId,
          this.selectedDays,
          this.selectedShiftsByDay,
          this.submitted) || ShiftPatternService.shiftHasError(dayId, this.selectedDays, this.selectedShiftsByDay, this.submitted)
      );
      if (dayErrorExists) {
        this.disabled = false;
        return;
      }
      this.disabled = true;
      this.update()
    },

    update() {
      this.disabled = true;
      const patterns = ShiftPatternService.prepareRequestData(this.selectedShiftsByDay, this.shiftLists);
      const request = {
        pattern_name: this.pattern_name,
        pattern_group: this.pattern_group,
        patterns: patterns
      }
      axios.put('/shift-pattern/' + this.$route.params.id, request)
      .then((response) => {
        if (response.data) {
          this.showList();
          this.$notification.success('Shift Pattern updated successfully', {
            timer: 3,
            position: "bottomCenter"
          })
        }
      })
      .catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else if (error.response.status == 500) {
          this.$notification.error('Failed to update shift pattern', {
            timer: 3,
            position: "bottomCenter"
          })
        } else if (error.response.status == 422) {
          let errors = error.response.data.errors;
          this.printValidationError(error.response);
          if (errors.shift_patterns && errors.shift_patterns) {
            this.shiftErrorData = errors.shift_patterns;
          }
        } else if (error.response.status == 403) {
          this.$notification.error(error.response.data.message, {
            timer: 3,
            position: "bottomCenter"
          })
        }
        this.disabled = false;
        console.log("Shift Pattern Create API Error", error);
      })
    },

    changeTimeFormat(time) {
      return ShiftPatternService.changeTimeFormat(time);
    },

    showList() {
      this.$router.push({
        name : "shiftPatternList"
      });
    },

    handleDayChange(dayId) {
      return ShiftPatternService.defineDayChange(dayId, this.selectedDays, this.selectedShiftsByDay, this.shiftLists, this.$set);
    },

    handleShiftChange(dayId) {
      this.shiftErrorData = null;
      return ShiftPatternService.defineShiftChange(dayId, this.selectedDays, this.selectedShiftsByDay, this.$set);
    },
  },

  computed: {
    hasAnyShiftSelected() {
      return ShiftPatternService.hasAnyShiftSelected(this.selectedShiftsByDay)
    },

    hasAnyDaySelected() {
      return ShiftPatternService.hasAnyDaySelected(this.selectedDays)
    },

    showGlobalPatternError() {
      return this.submitted && !this.hasAnyShiftSelected && !this.hasAnyDaySelected;
    },
  },

  created() {
    ShiftPatternService.initDays(
      this.days,
      this.selectedDays,
      this.selectedShiftsByDay,
      this.$set
    );
    this.fetchPatternDetail();
    this.fetchShifts();
  },

  mounted() {
    this.isLoading = true;
  },
};

function removeValidationError(el) {
  const next = el.nextElementSibling;
  if (next && next.classList.contains('validation-error')) {
    next.remove();
  }
}

function insertValidationError(el, message) {
  const div = document.createElement('div');
  div.className = 'text-danger validation-error';
  div.textContent = message;
  el.after(div);
}
